<template>
    <div class="pa-4 ba-1 rounded">
        <h3 v-if="heading" class="text-h5 mb-2">{{ heading }}</h3>
        <div :style="{ height: height }">
            <transition appear name="fade-transition" mode="out-in">
                <skeleton-table-simple
                    v-if="loading"
                    :rows="10"
                    :cols="3"
                    :style="{ height: height !== null ? '100%' : null }"
                />

                <div v-else-if="ready && !empty">
                    <slot name="default" />
                </div>

                <p v-else-if="ready && empty" class="text-caption text--secondary">
                    {{ $t('data') }} {{ $t('not_found') }}
                </p>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReportWidget',
    props: {
        heading: {
            type: String,
            default: null
        },
        height: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        ready: {
            type: Boolean,
            default: false
        },
        empty: {
            type: Boolean,
            default: false
        }
    }
};
</script>
